import React, {Component} from 'react';
import PropTypes from "prop-types";
import Icon from "./Icon";
import TagOverlay from "./TagOverlay";

class SuggestButton extends Component {
  static propTypes = {
    object: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      overlay: false
    }
  }

  onButtonClick(e) {
    if (e) {
      e.preventDefault();
    }

    this.setState({
      overlay: !this.state.overlay
    })
  }

  render() {
    const { className, object } = this.props;
    let classes = ['btn btn-default btn-block btn-sm'];
    if (className) {
      classes = [className];
    }

    return (
      <React.Fragment>
        <button className={classes.join(" ")} onClick={this.onButtonClick.bind(this)}>
          <Icon icon={"plus"} /> Add a Tag
        </button>
        <TagOverlay object={object} visible={this.state.overlay} onClose={this.onButtonClick.bind(this)} />
      </React.Fragment>
    );
  }
}

export default SuggestButton;